import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { blog } from '../../modules/store'
import './Blog.css'
import Moment from 'react-moment'
import loaderGif from '../../img/gif-load.gif'
import adokulturaLogo from '../../img/adokultura.png'

export default observer(
  class Blog extends Component {
    render() {
      return (
        <div className='content-pane'>
          <h2>Blog</h2>
          <a href='https://adokultura.hu' target='_blank'>
            <div style={{ backgroundColor: '#3b8dbd', textAlign: 'center' }}>
              <img src={adokulturaLogo} />
            </div>
          </a>
          {/* {blog.posts.length ?
                  (blog.posts.map((post, index) =>
                    <div key={index}>
                      <h3 className="blog-item-header"><a href={post.link} target = '_blank'> <div dangerouslySetInnerHTML={{ __html: post.title}} /> </a></h3>
                      <Moment className="blog-item-date" format="YYYY.MM.DD.">
                        {post.date}
                      </Moment>
                      <div className="blog-item-text" dangerouslySetInnerHTML={{ __html: post.shortText }} />
                    </div>
                  )) :
                  <div className="loader-gif-container">
                    <img className="loader-gif" src={loaderGif} />
                  </div>
                } */}
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/blog/Blog.js